import React from 'react';

const Loader = ({ message = "Loading..." }) => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-indigo-50 flex items-center justify-center p-4">
            <div className="text-center max-w-md mx-auto">
                <div className="relative w-20 h-20 mx-auto mb-4">
                    <img
                        src="/assets/logo.png"
                        alt="Website Logo"
                        className="w-full h-full object-contain"
                        style={{
                            animation: 'fadeInOut 2s ease-in-out infinite',
                            opacity: 0
                        }}
                        onError={(e) => {
                            console.error('Logo failed to load:', e);
                            e.currentTarget.style.display = 'none';
                        }}
                    />
                </div>
                <p className="text-gray-600 animate-pulse text-lg font-medium">{message}</p>
            </div>
            <style>
                {`
                    @keyframes fadeInOut {
                        0% {
                            opacity: 0;
                            transform: scale(0.8);
                        }
                        50% {
                            opacity: 1;
                            transform: scale(1);
                        }
                        100% {
                            opacity: 0;
                            transform: scale(0.8);
                        }
                    }
                `}
            </style>
        </div>
    );
};

// Fallback component with faded logo
const ImageFallback = ({ className = "w-full h-full object-cover" }) => {
    return (
        <div className={`${className} bg-gray-100 flex items-center justify-center rounded p-4`}>
            <img
                src="/assets/logo.png"
                alt="Placeholder"
                className="w-1/2 h-1/2 object-contain opacity-30"
                onError={(e) => {
                    console.error('Fallback logo failed to load:', e);
                    e.currentTarget.style.display = 'none';
                }}
            />
        </div>
    );
};

// Simple image component with fallback and loading state
const ImageWithFallback = ({ src, alt, className = "w-full h-full object-cover", onClick }) => {
    const [hasError, setHasError] = React.useState(false);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);

    const handleLoad = () => {
        setIsLoaded(true);
        setIsLoading(false);
    };

    const handleError = () => {
        setHasError(true);
        setIsLoading(false);
    };

    // If src is null, undefined, or empty, show fallback immediately
    if (!src) {
        return <ImageFallback className={className} />;
    }

    if (hasError) {
        return <ImageFallback className={className} />;
    }

    return (
        <div className="relative" onClick={onClick}>
            {isLoading && (
                <div className={`absolute inset-0 flex items-center justify-center bg-gray-100 ${className}`}>
                    <div className="w-6 h-6 relative">
                        <div className="absolute inset-0 border-2 border-gray-200 rounded-full"></div>
                        <div className="absolute inset-0 border-2 border-transparent border-t-blue-500 rounded-full animate-spin"></div>
                    </div>
                </div>
            )}
            <img
                src={src}
                alt={alt}
                className={className}
                onLoad={handleLoad}
                onError={handleError}
                style={{
                    opacity: isLoaded ? 1 : 0,
                    transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out',
                    transform: isLoaded ? 'scale(1)' : 'scale(0.95)'
                }}
            />
        </div>
    );
};

export default Loader;
export { ImageWithFallback, ImageFallback };